import axios from 'axios';
import { metaValue } from 'helpers/dom-helper';
import dayjs from 'lib/dayjs';
import showToast from 'lib/toast_notification';

// Update a specific event with the server
window.calendarUpdateEvent = async (newEvent, oldEvent, options = {}) => {
  const {
    demoMode,
    eventId,
    mockSession,
    modeId,
    scheduleeId,
    schedulerId,
    typeId,
    timeZone,
    isCustomTitle,
    recurring,
    locatableId,
    locatableType,
    address,
  } = newEvent.extendedProps;
  const { afterCommit, ...newAttrs } = options;

  try {
    // Set the event to not be editable while we are updating it.
    newEvent.setProp('editable', false);
    const attrs = {
      title: isCustomTitle ? oldEvent.title : null, // Titles may be custom or a default value that gets set by the event mode and type.
      demo_mode: demoMode,
      mock_session: mockSession,
      all_day_event: newEvent.allDay,
      start_time: newEvent.start.toISOString(),
      end_time: newEvent.end?.toISOString(), // Nullable if dragged to all day section.
      split_time: oldEvent.start.toISOString(),
      duration: newEvent.end ? dayjs(newEvent.end).diff(dayjs(newEvent.start), 'minutes') : null,
      scheduler_id: schedulerId,
      schedulee_id: scheduleeId,
      time_zone: timeZone,
      update_type: recurring ? '1' : '3', // Only update the current instance.
      mode_id: modeId,
      type_id: typeId,
      locatable_id: locatableId || null,
      locatable_type: locatableType || null,
      address_attributes: address || {},
      ...newAttrs,
    };

    // If the event is dragged to the all-day section or if an all-day event is resized.
    if (newEvent.allDay) {
      const start = dayjs(newEvent.start).format('YYYY-MM-DD');
      attrs.start_time_date = start;
      // Fullcalendar bug: end date is exclusive, so we need to subtract a day.
      attrs.end_time_date = newEvent.end ? dayjs(newEvent.end).subtract(1, 'day').format('YYYY-MM-DD') : start;
    }

    // If the event is dragged from the all-day section to the grid.
    if (!newEvent.allDay && !newEvent.end) {
      const duration = Number.parseInt(metaValue('default-event-duration'), 10) || 0;
      attrs.end_time = dayjs(newEvent.start).add(duration, 'minutes').toISOString();
      attrs.duration = duration;
    }

    const { data } = await axios.patch(`/events/${eventId}`, { event: attrs });
    // Replace the old event with the new event. If this gets janky, refetch all events after this using
    // `window.calendar.refetchEvents()`
    newEvent.remove();
    afterCommit?.(data);
  } catch (error) {
    const message =
      error.response?.data?.errors?.map((e) => e.detail)?.join('\n') ||
      error.message ||
      'We ran into an error while updating the event.';
    showToast(message, { type: 'error', delay: 5000 });
    window.calendar.refetchEvents();
  }
};
